module.exports = __webpack_public_path__ + "static/img/103044.fd2f5bd4.png";